const Colors = [
    [
        "#3400a3",
        "#d50c42",
        "#19cc33",
    ],
    [
        "#0000ff",
        "#00aB60",
    ],
    [
        "#0000ff",
        "#00aB60",
    ],
    [
        "#fa3219",
        "#fefcfb",
    ],
    [
        "#0000ff",
        "#fefcfb",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "#fefcfb",
        "#000000",
    ],
    [
        "#2a2430",
        "#ca861d",
        "#6b7b93",
        "#994720",
        "#eddbd4",
        "#aa9a76",
        "#4c6c9d",
        "#49532c"
    ],
    [
        "#2a2430",
        "#ca861d",
        "#6b7b93",
        "#994720",
        "#eddbd4",
        "#aa9a76",
        "#4c6c9d",
        "#49532c"
    ],
    [
        "#2A3177",
        "#D50C16",
    ],
    [
        "#005742",
        "#EBA503",
    ],
    [
        "#005742",
        "#EBA503",
        "#DFDAC7",
        "#2A3177",
        "#D50C16",
        "#845A9D",
    ],
    [
        "#1D2747",
        "#005028",
        "#2A4B99",
        "#EA950D",
    ],
    [
        "#8B5BA2",
        "#F2A608",
        "#E6DBCC",
    ],
    [
        "#10120F",
        "#F44A0F",
        "#0E8DD2",
        "#10971F",
        "#5AA316",
        "#E53F0F",
    ],
    [
        "#2D1922",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#0a1128",
        "#05183e",
        "#001f54",
        "#023066",
        "#034078",
        "#0b618d",
        "#1282a2",
        "#88bfcf",
        "#c3dee5",
        "#fefcfb",
        "#ffdc73",
        "#ffcf40",
        "#ffbf00",
        "#bf9b30",
        "#a67c00",
        "#FFF9CB"
    ],
    [
        "#ff4535",
        "#ffffff",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#142A36",
        "#F0C667",
        "#7BA6BC",
        "#D24C23",
        "#672B35",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#f9cd22",
        "#3cb371",
        "#e94e19",
        "#203b75",
        "#cc0028",
    ],
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#544E47",
        "#CFC7B9",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#E15147",
        "#4AAD8B",
    ],
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#2a4d9b",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#3e8740",
        "#fa3219",
        "#fca503",
        "#2969de",
        "#ffffff",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#10120F",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "#fefcfb",
        "#000000",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "#fefcfb",
        "#000000",
    ],
    [
        "#0000ff",
        "#00aB60",
    ],
    [
        "#0000ff",
        "#fefcfb",
    ],
]
export default Colors